import type { BulkApprovalWorkflowResult } from '@risksmart-app/trpc/src/helpers/run-bulk-approval-workflow';
import type { DeleteControlsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteControlsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteControls = createMutationHook({
  name: 'deleteControls',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.control.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]): { Ids: string[] } => ({ Ids: ids }),
  // The bulk gate partitions the batch; any ids that required approval got a CR
  // created server-side — surface those on the CR read feeds immediately.
  refreshChangeRequestFeedsWhen: (result: BulkApprovalWorkflowResult) =>
    result.changeRequestIds.length > 0,
  invalidate: (trpc) => [
    trpc.frontend.control.register.queryKey(),
    trpc.frontend.control.controlById.queryKey(),
    trpc.frontend.control.controlsBasic.queryKey(),
  ],
  // BulkApprovalWorkflowResult partitions the batch: `applied` carries the rows
  // actually deleted; gate-required rows come back in `changeRequestIds` with no
  // error thrown. The legacy GraphQL shape only reports the deleted count.
  mapResponse: (
    result: BulkApprovalWorkflowResult
  ): DeleteControlsMutation => ({
    deleteControlsById: {
      __typename: 'GenericMutationOutput',
      affected_rows: result.applied.length,
    },
  }),
  graphqlDocument: DeleteControlsDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['control', 'linked_item', 'control_aggregate'],
});
